import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { safeRedirect } from '@/shared/lib'

import { RegisterPage } from '@/features/auth'

import { AuthPending } from '@/app/layouts'
import { sessionQuery } from '@/app/router/session'

/** `returnTo` comes from the URL, so it is validated before it is ever used. */
const registerSearchSchema = z.object({
  returnTo: z.string().optional().catch(undefined),
})

/**
 * Both of registration's fields carry a permanent hint — the username rule and
 * the password length — so its card is 50px taller than sign-in's. The
 * placeholder says so rather than settling in the middle of the two.
 */
const RegisterPending = () => <AuthPending hasFieldHints />

export const Route = createFileRoute('/_public/register')({
  validateSearch: registerSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery()).catch(() => null)

    // Someone already signed in has no business on a sign-up form.
    if (session !== null) {
      // Absolute URLs are rejected; otherwise this is an open redirect.
      throw redirect({ href: safeRedirect(search.returnTo), replace: true })
    }
  },
  pendingComponent: RegisterPending,
  component: RegisterPage,
})
